import { useState, useEffect } from 'react';
import { EDGE_FUNCTIONS_URL } from '@/lib/api-config';

interface TierInfo {
  totalCustomers: number;
  currentTier: 'beta' | 'early90' | 'regular';
  tierName: string;
  price: number;
  spotsRemaining: number | null;
  tierMessage: string;
  couponCode: string | null;
  priceId: string;
  shouldAutoApplyCoupon: boolean;
}

export function useTierInfo() {
  const [tierInfo, setTierInfo] = useState<TierInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchTierInfo = async () => {
      try {
        const response = await fetch(`${EDGE_FUNCTIONS_URL}/get-customer-count`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setTierInfo(data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch tier info'));
      } finally {
        setLoading(false);
      }
    };

    fetchTierInfo();
  }, []);

  return { tierInfo, loading, error };
}
